const lifts = [
    {
        "id": 1,
        "name": "Forklifts",
        "filedid": "fork",
        "products": [
            {
                "id": 1,
                "name": "Voltas",
                "capacity": "3MT",
                "quantity": "4 nos.",
                "details": "3MT capacity",
                "Image": "/product/lifts/fork/Forklift (1).jfif"
            },
            {
                "id": 2,
                "name": "Voltas",
                "capacity": "3MT",
                "quantity": "1 nos.",
                "details": "3MT capacity",
                "Image": "/product/lifts/fork/Forklift (2).jfif"
            },
            {
                "id": 3,
                "name": "Voltas",
                "capacity": "3MT",
                "quantity": "2 nos.",
                "details": "3MT capacity",
                "Image": "/product/lifts/fork/Forklift (4).jfif"
            }
        ]
    },
    {
        "id": 2,
        "name": "Manlifts",
        "filedid": "man",
        "products": [
            {
                "id": 1,
                "name": "Volvo prime movers",
                "capacity": "150 MT puller",
                "quantity": "2 nos.",
                "details": "FH 520 HP",
                "Image": "/product/lifts/man/Manlift (1).jfif"
            },
            {
                "id": 2,
                "name": "Volvo prime movers",
                "capacity": "120 MT puller",
                "quantity": "4 nos.",
                "details": "FH 400 HP",
                "Image": "/product/lifts/man/Manlift (2).jfif"
            },
            {
                "id": 3,
                "name": "Man prima mover",
                "capacity": "80 MT puller",
                "quantity": "1 no.",
                "details": "280 HP",
                "Image": "/product/lifts/man/Manlift (3).jfif"
            },
            {
                "id": 4,
                "name": "TATA Prima Puller",
                "capacity": "80 MT puller",
                "quantity": "2 Nos.",
                "details": "280 HP",
                "Image": "/product/lifts/man/Manlift (4).jfif"
            },
            {
                "id": 5,
                "name": "Hydraulic Axles (TRATEC)",
                "capacity": "18 MT per axle",
                "quantity": "54 No.",
                "details": "Axles",
                "Image": "/product/lifts/man/Manlift (5).jfif"
            },
            {
                "id": 6,
                "name": "Hydraulic axles (Goldhofer)",
                "capacity": "26 MT per axle",
                "quantity": "24 No.",
                "details": "Axles",
                "Image": "/product/lifts/man/Manlift (6).jfif"
            },
            {
                "id": 7,
                "name": "Telescopic spacer beam",
                "capacity": "50 feet",
                "quantity": "1 no.",
                "details": "compatible for tratec as well as goldhofer",
                "Image": "/product/lifts/man/Manlift (7).jfif"
            },
            {
                "id": 8,
                "name": "Bolsters",
                "capacity": "-",
                "quantity": "2 sets",
                "details": "-",
                "Image": "/product/lifts/man/Manlift (8).jfif"
            },
            {
                "id": 9,
                "name": "Stands",
                "capacity": "-",
                "quantity": "50 No.",
                "details": "-",
                "Image": "/product/lifts/man/Manlift (9).jfif"
            },
            {
                "id": 10,
                "name": "Beams",
                "capacity": "-",
                "quantity": "20 No.",
                "details": "-",
                "Image": "/product/lifts/man/Manlift (10).jfif"
            }
        ]
    }
];
export default lifts;